import { Flex, HStack, Text, VStack } from '@chakra-ui/react';
import ShieldSharpIcon from '@gamma/ui/icons/ShieldSharpIcon';
import DatabaseSharpIcon from '@gamma/ui/icons/DatabaseSharpIcon';
import ConversionPathSharpIcon from '@gamma/ui/icons/ConversionPathSharpIcon';
import NotificationsSharpIcon from '@gamma/ui/icons/NotificationsSharpIcon';
import { type ElementType } from 'react';
import { Action, RecommendedAction } from '../../types/agenticTriageReport';
import { useParseBackticks } from '@investigator/shared/hooks';

interface ActionConfig {
  icon: ElementType;
}

/**
 * Configuration mapping for action types to their UI elements
 */
const ACTION_CONFIG: Record<RecommendedAction, ActionConfig> = {
  [RecommendedAction.IsolateEntity]: {
    icon: ShieldSharpIcon,
  },
  [RecommendedAction.PreserveEvidence]: {
    icon: DatabaseSharpIcon,
  },
  [RecommendedAction.BlockConnections]: {
    icon: ConversionPathSharpIcon,
  },
  [RecommendedAction.SuppressEntity]: {
    icon: NotificationsSharpIcon,
  },
};

export interface RecommendedActionItemProps {
  action: Action;
}

export const RecommendedActionItem = ({
  action,
}: RecommendedActionItemProps): JSX.Element | null => {
  const { parseBackticks } = useParseBackticks();
  const actionType = action.type;
  const config = ACTION_CONFIG[actionType];
  const Icon = config?.icon;

  if (!config) {
    return null;
  }

  return (
    <VStack align="flex-start" spacing={3}>
      <HStack spacing={2} align="flex-start">
        {/* Icon Box */}
        <Flex
          w="32px"
          h="32px"
          borderRadius="4px"
          bg="layer.1.active"
          align="center"
          justify="center"
          flexShrink={0}
        >
          <Icon boxSize={5} />
        </Flex>

        {/* Description */}
        <Text color="text.primary" textStyle="body-sm" flex={1}>
          {parseBackticks(action.description)}
        </Text>
      </HStack>
    </VStack>
  );
};
